"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicinalProductCountryLanguage = void 0;
/**
 * Detailed definition of a medicinal product, typically for uses other than direct patient care (e.g. regulatory use).
 */
var MedicinalProductCountryLanguage = /** @class */ (function () {
    function MedicinalProductCountryLanguage() {
    }
    return MedicinalProductCountryLanguage;
}());
exports.MedicinalProductCountryLanguage = MedicinalProductCountryLanguage;
